module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/~/babel-runtime/regenerator/index.js
// module id = 95
// module chunks = 0